// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fbc9e4fe","453":"dd007332","455":"2de56f5e"}[chunkId] + ".chunk.js";
};